module.exports = __webpack_public_path__ + "img/5.bba0c5e5.webp";